import { ReqInfoMocked } from './req-info.mocked';
import { EvnetData } from '../../models/events.model';

export const eventsMocked: EvnetData[] = [];
export function getEvents(reqInfo: ReqInfoMocked, urlParams: Array<string>) {
    return eventsMocked;
}
